import { makeMultiSearch, makeSearch } from "../../UI/Search/Search";
import PersonService from "../../../Services/Person.service";
const makeSearchArgs = {
    loadOptions: (search, options) => {
        if (options.forceEmptyReturn) {
            return new Promise((resolve) => {
                resolve([]);
            });
        }
        return PersonService.searchWithMeetingAvailability({
            personTypeInternalNames: options.personTypeInternalNames,
            ids: options.ids,
            excludePersonIds: options.excludePersonIds,
            query: search,
        });
    },
    label: "fullName",
    value: "studentId",
};
export const PersonWithMeetingAvailabilitySearch = makeSearch(makeSearchArgs);
export const PersonWithMeetingAvailabilityMultiSearch = makeMultiSearch(makeSearchArgs);
